import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
import bayviewLogo from '../../client/static/bayview-yards-logo.png';
import areaxoLogo from '../../client/static/areaxo-logo.png';

export const HUB_LOCATION_LINKS = [
  {
    slug: 'bayviewyards',
    label: 'Bayview Yards',
    to: '/bayviewyards/information-desk',
    kind: 'image' as const,
    src: bayviewLogo,
    imageClassName: 'h-24 w-auto object-contain',
  },
  {
    slug: 'killaloe',
    label: 'KO',
    to: '/killaloe/information-desk',
    kind: 'text' as const,
    textClassName: 'text-4xl sm:text-5xl font-bold tracking-tight',
  },
  {
    slug: 'areaxo',
    label: 'Area X.O',
    to: '/areaxo/information-desk',
    kind: 'image' as const,
    src: areaxoLogo,
    imageClassName: 'h-10 w-auto object-contain',
  },
];

export function HubLocationLinks({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-col sm:flex-row items-center justify-center gap-12', className)}>
      {HUB_LOCATION_LINKS.map((hub) => (
        <Link
          key={hub.slug}
          to={hub.to}
          title={hub.label}
          className="flex h-28 w-48 items-center justify-center opacity-80 hover:opacity-100 transition-opacity"
        >
          {hub.kind === 'image' ? (
            <img src={hub.src} alt={hub.label} className={hub.imageClassName} />
          ) : (
            <span className={hub.textClassName}>{hub.label}</span>
          )}
        </Link>
      ))}
    </div>
  );
}
